<template>
  <div class="card-body bg-light">
    <h5 class="text-left">
      {{ formTitle }}
    </h5>

    <form class="form">
      <ReadOnlyField
        :value="item[displayFieldName]"
        :fieldName="itemType"
        :displayLabel="true"
      />
      <SelectField
        fieldName="Scratch type"
        placeholderText="Select scratch type"
        :displayLabel="true"
        :selectOptions="scratchTypes"
        displayFieldName="display_name"
        keyName="uuid"
        v-model="selectedScratchType"
        fieldDescription="Required"
      />
      <TextField
        fieldName="Location"
        v-model="location"
        :displayLabel="true"
        placeholderText="Where the scratch occurred"
        fieldDescription="Required"
      />
      <div class="form-group text-left small">
        <label for="scratched_at">Scratched at</label>
        <input
          type="datetime-local"
          id="scratched_at"
          class="form-control form-control-sm"
          v-model="scratchedAt"
        />
        <small class="form-text text-muted">
          Optional &mdash; leave blank to use the current time
        </small>
      </div>
      <NotesField v-model="notes" />
      <SubmitButton
        :buttonText="formTitle"
        :loading="loading"
        :isDisabled="!canSubmit"
        @submit="emitForm"
      />
    </form>
  </div>
</template>

<script>
import TextField from "@/components/formFieldComponents/TextField.vue";
import NotesField from "@/components/formFieldComponents/NotesField.vue";
import SelectField from "@/components/formFieldComponents/SelectField.vue";
import ReadOnlyField from "@/components/formFieldComponents/ReadOnlyField.vue";
import SubmitButton from "@/components/formFieldComponents/SubmitButton.vue";

export default {
  name: "Scratch",
  props: {
    formTitle: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    item: Object,
    itemType: String,
    displayFieldName: String,
  },
  data() {
    return {
      selectedScratchType: null,
      location: "",
      scratchedAt: "",
      notes: "",
    };
  },
  computed: {
    scratchTypes() {
      const me = this.$store.state.usersStore.me;
      return me && me.scratch_types ? me.scratch_types : [];
    },
    canSubmit() {
      return !!this.selectedScratchType && !!this.location;
    },
  },
  methods: {
    emitForm() {
      if (!this.canSubmit) {
        return;
      }
      const payload = {
        scratch_type: this.selectedScratchType.uuid,
        location: this.location,
        notes: this.notes,
      };
      if (this.scratchedAt) {
        // datetime-local has no timezone — convert to a full ISO string
        // using the user's local timezone offset.
        payload.scratched_at = new Date(this.scratchedAt).toISOString();
      }
      this.$emit("form-submission", payload);
    },
  },
  components: {
    TextField,
    NotesField,
    SelectField,
    ReadOnlyField,
    SubmitButton,
  },
};
</script>

<style scoped></style>
